import React from 'react';
import './Button.scss'

const Button = React.forwardRef((props, ref) => {
	const {
	  title,
	  secondary,
	  arrowPosition,
	  onClick,
	  active,
	  small,
	  hideTextOnMobile,
	  className,
	  children,
	  hasHover,
	} = props;
  
	const classSmall = small ? 'tos-button--small' : '';
	const classActive = active === 'true' ? 'tos-button--active' : '';
	const classSecondary = secondary ? 'tos-button--secondary' : '';
	const classArrowPosition = arrowPosition
	  ? `tos-button--${arrowPosition}`
	  : '';
	const classHidden = hideTextOnMobile ? 'tos-button--hideTextOnMobile' : '';
	const classHover = hasHover ? 'tos-button--hover' : '';
	const classHasChildren = children ? 'tos-button--has-children' : '';
  
	return (
	  <button
		className={`tos-button ${classSmall} ${classHidden} ${classActive} ${classSecondary} ${classArrowPosition} ${className} ${classHover} ${classHasChildren}`}
		onClick={onClick}
		ref={ref}
	  >
		{arrowPosition === 'left' && children}
		<span>{title}</span>
		{arrowPosition === 'right' && children}
	  </button>
	);
  });
  
  export default Button;
  